module.exports = __webpack_public_path__ + "media/assets/images/nosco_overview/hero_image-27c801820d80e6a2869b39ba615e3051.png";